export default __webpack_public_path__ + "static/media/signup_1.0ed34524.jpg";